import { useAnalytics } from '@cld/analytics';

// TODO: Implement custom analytics provider to allow for testing of events
export const useTrackEvent = (category = 'programmable media') => useAnalytics(category);
